import { motion } from "framer-motion";
import teeth from "../../assets/page_loader.png";

export default function PageLoader() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-xl bg-white/40 overflow-hidden"
    >
      {/* 🌈 Premium Background Glow */}
      <div className="absolute -left-20 top-20 h-60 w-60 rounded-full bg-[#e9d6aa]/50 blur-3xl animate-pulse" />
      <div className="absolute right-0 top-[30%] h-72 w-72 rounded-full bg-[#f2e6c9]/40 blur-3xl animate-pulse" />
      <div className="absolute left-[35%] bottom-10 h-56 w-56 rounded-full bg-[#f8efdb]/50 blur-3xl animate-pulse" />

      {/* 🦷 YOUR ORIGINAL 3D FLIP */}
      <motion.img
        src={teeth}
        alt="Loading"
        className="w-[120px] md:w-[160px] relative z-10"
        animate={{
          rotateY: 360, // ✅ your original effect
        }}
        transition={{
          repeat: Infinity,
          duration: 2,
          ease: "linear",
        }}
        style={{
          transformStyle: "preserve-3d",
        }}
      />
    </motion.div>
  );
}